<div class="w-full overflow-visible! m-0! flex flex-col">
  <div class="flex items-center justify-between gap-2 overflow-hidden">
    <label class="form-label truncate flex-1 m-0">
      {{ label }}
    </label>
  </div>

  <div class="w-full relative mt-2">
      <app-ad-date-picker-wrapper
        [date]="selectedDate"
        [placeholder]="'Select date'"
        [dateRestriction]="dateRestriction"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [enableTime]="enableTime"
        [disabled]="readonly"
        (dateSelected)="updateAdDate($event)"
      >
      </app-ad-date-picker-wrapper>
  </div>
</div>
